<template>
    <div>

        <div class="bk"></div>

        <div class="g-banner pr">
            <!--<div class="menuwrap">-->
            <!--</div>-->
            <div class="menuContent">
                <div class="item">
                    <a href="javascript:void(0);" target="_blank">
                        <span class="group">安全管理人员</span>
                        <i class='icon-right2'></i>
                        <!-- 安全管理人员 -->
                        <div class="submenu hide aa">
                            <div class="innerBox clearfix">
                                <div class="cates-box">
                                    <div class="fe-advance-box clearfix" v-for="(value, key) in aqglworksban">
                                        <div class="banner-line">
                                            <span class="bold mr10 l small-title">{{key}}</span>
                                        </div>
                                        <div class="tag-box l">
                                            <a v-for="item in value" @click="goclass(item._id)">
                                                {{item.gzxiangmu}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="item">
                    <a href="javascript:void(0);" target="_blank">
                        <span class="group">特种作业人员</span>
                        <i class='icon-right2'></i>

                        <div class="submenu hide aa bb">
                            <div class="innerBox clearfix">
                                <div class="cates-box">
                                    <div class="fe-advance-box clearfix" v-for="(value, key) in tzzyworksban">
                                        <div class="banner-line">
                                            <span class="bold mr10 l small-title">{{key}}</span>
                                        </div>
                                        <div class="tag-box l">
                                            <a v-for="item in value" @click="goclass(item._id)">
                                                {{item.gzxiangmu}}
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="item">
                    <a href="javascript:void(0);" target="_blank">
                        <span class="group">特种设备作业人员</span>
                        <i class='icon-right2'></i>
                        <div class="submenu hide aa cc">
                            <div class="innerBox clearfix">
                                <div class="cates-box">
                                    <div class="fe-advance-box clearfix" v-for="(value, key) in tzsbworksban">
                                        <div class="banner-line">
                                            <span class="bold mr10 l small-title">{{key}}</span>
                                        </div>
                                        <div class="tag-box l">
                                            <a v-for="item in value" @click="goclass(item._id)">
                                                {{item.gzxiangmu}}
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="item">
                    <a href="javascript:void(0);" target="_blank">
                        <span class="group">非高危行业</span>
                        <i class='icon-right2'></i>
                        <div class="submenu hide aa dd">
                            <div class="innerBox clearfix">
                                <div class="cates-box">
                                    <div class="fe-advance-box clearfix" v-for="(value, key) in fgwhyworksban">
                                        <div class="banner-line">
                                            <span class="bold mr10 l small-title">{{key}}</span>
                                        </div>
                                        <div class="tag-box l">
                                            <a v-for="item in value" @click="goclass(item._id)">
                                                {{item.gzxiangmu}}
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="item">
                    <a href="javascript:void(0);" target="_blank">
                        <span class="group">职业健康安全培训</span>
                        <i class='icon-right2'></i>
                        <div class="submenu hide aa ee">
                            <div class="innerBox clearfix">
                                <div class="cates-box">
                                    <div class="fe-advance-box clearfix" v-for="(value, key) in zyjkworksban">
                                        <div class="banner-line">
                                            <span class="bold mr10 l small-title">{{key}}</span>
                                        </div>
                                        <div class="tag-box l">
                                            <a v-for="item in value" @click="goclass(item._id)">
                                                {{item.gzxiangmu}}
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

            <div class="g-banner-content">
                <div class="g-banner-box swiper-wrapper">
                    <div v-for="item in banners" class="swiper-slide">
                        <img :src="item.imgDizhi">
                    </div>

                    <!-- 如果需要分页器 -->
                    <div class="banner-dots"></div>
                    <a href="javascript:;" class="banner-anchor prev icon-left2"></a>
                    <a href="javascript:;" class="banner-anchor next icon-right2"></a>
                    <!--<div class="cb"></div>-->
                </div>

                <div class='path-banner clearfix'>
                    <a @click="goclass(item.id)" v-for="item in homehots">
                        <i class="i-web">
                            <img :src="item.imgHotwork">
                        </i>
                        <p class="tit">{{item.hotGzleibie}}</p>
                        <p class="desc">{{item.hotGzxiangmu}}</p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper/dist/js/swiper.min';
    import axios from 'axios';
    import 'swiper/dist/css/swiper.min.css';
    import './../assets/css/banner.css';

    export default {
        name: "Banner",
        data() {
            return {
                aqglworks: [],
                tzzyworks: [],
                tzsbworks: [],
                fgwhyworks: [],
                zyjkworks: [],

                aqglworksban: {},
                tzzyworksban: {},
                tzsbworksban: {},
                fgwhyworksban: {},
                zyjkworksban: {},

                banners: [],
                homehots: [],

            }
        },
        components: {
            Swiper,
            axios
        },
        methods: {
            getdatascesehi: function () {
                axios.post("/Api/getworks").then(res => {
                    if (res.statusText == "OK") {
                        var works = res.data.data;
                        for (var obj in works) {
                            //给数据分类
                            switch (works[obj].gzleixing) {
                                case "安全管理人员":
                                    this.aqglworks.push(works[obj]);
                                    break;
                                case "特种作业人员":
                                    this.tzzyworks.push(works[obj]);
                                    break;
                                case "特种设备作业人员":
                                    this.tzsbworks.push(works[obj]);
                                    break;
                                case "非高危行业":
                                    this.fgwhyworks.push(works[obj]);
                                    break;
                                case "职业健康安全培训":
                                    this.zyjkworks.push(works[obj]);
                                    break;
                            }
                        }
                        //传入分类获取banner展示数据
                        this.aqglworksban = this.getbannerwork(this.aqglworks);
                        this.tzzyworksban = this.getbannerwork(this.tzzyworks);
                        this.tzsbworksban = this.getbannerwork(this.tzsbworks);
                        this.fgwhyworksban = this.getbannerwork(this.fgwhyworks);
                        this.zyjkworksban = this.getbannerwork(this.zyjkworks);

                    }
                });

                axios.post("/Api/getbanner").then(res => {
                    if (res.statusText == "OK") {
                        this.banners = res.data.data;
                        setTimeout(function () {
                            new Swiper('.g-banner-content', {
                                pagination: {
                                    el: '.banner-dots',
                                    clickable: true,
                                },
                                navigation: {
                                    nextEl: '.next',
                                    prevEl: '.prev',
                                },
                                effect: 'fade',
                                autoplay: {
                                    delay: 3000,//1秒切换一次
                                    disableOnInteraction: false,
                                },

                            });
                        }, 500)
                    }
                });

                axios.post("/Api/gethomehot").then(res => {
                    if (res.statusText == "OK") {
                        this.homehots = res.data.data;
                    }
                });

            },
            getbannerwork: function (dta) {
                var wode = {};
                for (var obj in dta) {
                    if (wode[dta[obj].gzleibie]) {
                        wode[dta[obj].gzleibie].push(dta[obj]);
                    } else {
                        wode[dta[obj].gzleibie] = [dta[obj]];
                    }
                }
                return wode;
            },
            goclass(data) {
                this.$router.push({
                    name: 'Class',
                    params: {
                        id: data
                    }
                });
            },
        },
        mounted: function () {
            this.getdatascesehi();

        }

    }
</script>
